export enum CommonKeys {
    Type = '$type',
    Values = '$values',
    Value = "Value",
    ID = "ID",
    Label = "Label",
    ShowLegend = "ShowLegendeOnPdf",
    ShowLabel = "ShowLabelOnPdf",
    IsReadonly = "IsReadonly"
}

export enum FormularModelKeys {
    VID = 'VorlagenID',
    FID = 'FormularID',
    Bezeichnung = 'Bezeichnung',
    Meta = 'Meta',
    Groups = 'Groups'
}